<template>
  <div class="container">
    <div class="card card-login mx-auto mt-5 centered-login">
      <img src="@/assets/login_logo.png" class="img-fluid p-3"/>
      <div class="card-body">
        <form @submit.prevent="submit">
          <div v-if="errors.length" class="alert alert-warning" role="alert" v-for="error in errors" :key="error">
            {{ error }}
          </div>
          <div class="form-group input-group-sm">
            <label class="font-weight-bold">Login</label>
            <input class="form-control" type="login" v-model="user.login" >
          </div>
          <div class="form-group input-group-sm">
            <label class="font-weight-bold">Hasło</label>
            <input class="form-control" type="password" v-model="user.password">
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col">
                <button type="submit" class="btn btn-primary btn-sm btn-block torre-btn">Zaloguj</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import userService from '@/service/userService'
import validator from 'validator'
import axios from 'axios'
import appConfig from '@/service/config'
import messageService from '@/service/messageService';
import un from 'underscore'
import MainPresenter from "@/service/MainPresenter"
import flashService from '@/service/flashService'

export default {
  name: 'Login',
  data () {
    return {
      mainPresenter: new MainPresenter(),
      errors: [],
      user: {
        login: '',
        password: ''
      }
    }
  },
  created: function () {
    this.assignBodyBackground();
  },
  destroyed() {
    var body = document.body;
    body.style = "";
  },
  methods: {
    getRandomUrl: function() {
      var max = 5;
      var randomIndex = Math.floor(Math.random() * max) + 1;
      var imgName = randomIndex + "-login.jpg";
      if (randomIndex < 10)
        imgName = "0" + imgName;
      var images = require.context('../assets/', false, /\.jpg$/)
      return images("./" + imgName);
    },
    assignBodyBackground: function () {
      var bcgUrl = this.getRandomUrl();
      var body = document.body;
      body.style = "background: url(" + bcgUrl + ") no-repeat center center fixed; ",
      "-webkit-background-size: cover;",
      "-moz-background-size: cover;",
      "-o-background-size: cover;",
      "background-size: cover;";
    },
    validate () {
      var err = []
      if (validator.isEmpty(this.user.login)) {
        err.push(messageService.getMessage("login.name.error"))
        return err
      }
      if (validator.isEmpty(this.user.password)) {
        err.push(messageService.getMessage("login.password.error"))
        return err
      }
      return err
    },
    submit () {
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      userService.logUser(this.user.login, this.user.password).then(response => {
        if (response.data.validUser) {
          userService.saveUser(response.data)
          userService.saveCurrentStore(response.data.storeId)
          flashService.add("welcomeMsg",{
            text: response.data.welcomeMessage
          });
          this.$router.push({name: 'main'})
        } else {
          this.errors = [messageService.getMessage("login.form.error")]
        }
      }, _ => {
        this.errors = [messageService.getMessage("server.error")]
      })
    }
  }
}
</script>

<style scoped lang="scss">
  $color: #333;

  label {
    color: $color
  }

  select {
    color: $color
  }

</style>



// WEBPACK FOOTER //
// src/components/Login.vue